export function loadEntryImages(entry){
	if (typeof entry.pictures == "string"){
        return entry.pictures.split(',');
    } else if (Array.isArray(entry.pictures)) {
        return entry.pictures;
    } else {
        return [];
    }
}